import { LocationFeatureFlagSettingName } from '@weave/schema-gen-ts/dist/schemas/payments/messages/location_settings/location_settings.pb';
import { useTranslation } from '@frontend/i18n';
import { PaymentsFeatureFlags, useLocationFeatureSwitch, useSelectedLocations } from '@frontend/payments-hooks';
import { useAppFlagStore } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { IdentifierToggle } from './identifier-toggle';

type OnlineBillPayIdentifierSettingsProps = {
  inMulti?: boolean;
};
export const OnlineBillPayIdentifierSettings = ({ inMulti }: OnlineBillPayIdentifierSettingsProps) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  const { locationIds } = useSelectedLocations();
  const { getFeatureFlagValue } = useAppFlagStore();

  const obpNewFieldsFF = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.ObpNewFields,
    locationIds: locationIds,
    strategy: 'ANY',
  });

  const { featureSettingSwitchProps: obpBirthdaySettingsProps } = useLocationFeatureSwitch({
    setting: LocationFeatureFlagSettingName.ONLINE_BILL_PAY_PATIENT_BIRTHDATE_ENABLED,
    errMsg: t('Error in toggling the receipt settings. Please try again.'),
    locationIds: locationIds,
  });
  const { featureSettingSwitchProps: obpAccountSettingsProps } = useLocationFeatureSwitch({
    setting: LocationFeatureFlagSettingName.ONLINE_BILL_PAY_PATIENT_IDENTIFIER_ENABLED,
    errMsg: t('Error in toggling the receipt settings. Please try again.'),
    locationIds: locationIds,
  });

  if (!obpNewFieldsFF) return null;

  return (
    <div css={inMulti ? { borderTop: `1px solid ${theme.colors.neutral20}`, paddingTop: theme.spacing(2) } : {}}>
      <Heading level={3} css={{ marginBottom: theme.spacing(2) }}>
        {t('Add Required Identification Fields')}
      </Heading>
      <IdentifierToggle
        name='toggle-send-receipt-automatically'
        label={t('Account, Chart, or Invoice ID field for customers')}
        switchProps={obpAccountSettingsProps}
      />
      <IdentifierToggle
        name='toggle-send-receipt-automatically'
        label={t('Date of Birth')}
        switchProps={obpBirthdaySettingsProps}
      />
    </div>
  );
};
